var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterAvailableAscIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9997 2.5C13.9997 2.36739 13.947 2.24021 13.8532 2.14645C13.7594 2.05268 13.6323 2 13.4997 2H7.49965C7.36705 2 7.23987 2.05268 7.1461 2.14645C7.05233 2.24021 6.99965 2.36739 6.99965 2.5C6.99965 2.63261 7.05233 2.75979 7.1461 2.85355C7.23987 2.94732 7.36705 3 7.49965 3H12.2927L2.14565 13.146C2.09917 13.1925 2.06229 13.2477 2.03713 13.3084C2.01197 13.3692 1.99902 13.4343 1.99902 13.5C1.99902 13.5657 2.01197 13.6308 2.03713 13.6916C2.06229 13.7523 2.09917 13.8075 2.14565 13.854C2.19214 13.9005 2.24733 13.9374 2.30807 13.9625C2.36881 13.9877 2.43391 14.0006 2.49966 14.0006C2.5654 14.0006 2.6305 13.9877 2.69124 13.9625C2.75198 13.9374 2.80717 13.9005 2.85366 13.854L12.9997 3.707V8.5C12.9997 8.63261 13.0523 8.75979 13.1461 8.85355C13.2399 8.94732 13.367 9 13.4997 9C13.6323 9 13.7594 8.94732 13.8532 8.85355C13.947 8.75979 13.9997 8.63261 13.9997 8.5V2.5Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterAvailableAscIcon);
export default __webpack_public_path__ + "static/media/filter-available-asc-icon.e8a406ec1ba67409d55267b1bf1e1341.svg";
export { ForwardRef as ReactComponent };